// import TwitterIcon from '@material-ui/icons/Twitter'
// import FacebookIcon from '@material-ui/icons/Facebook'
// import InstagramIcon from '@material-ui/icons/Instagram'
// import YouTubeIcon from '@material-ui/icons/YouTube'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import styled from 'styled-components'

const Footer = () => {

    const dispatch = useDispatch()

    return (
        <Wrapper>
            <div className='spacer-100'></div>
            {/* <Icons>
                <li><TwitterIcon fontSize="large"/></li>
                <li><FacebookIcon fontSize="large"/></li>
                <li><InstagramIcon fontSize="large"/></li>
                <li><YouTubeIcon fontSize="large"/></li>
            </Icons>
            <div className='spacer-50'></div> */}
            <Menu>
                <li onClick={()=>dispatch(push('/about'))}>T3とは</li>
                <li onClick={()=>dispatch(push('/contact'))}>お問い合わせ</li>
                <li onClick={()=>dispatch(push('/company'))}>会社概要</li>
                <li onClick={()=>dispatch(push('/privacypolicy'))}>プライバシーポリシー</li>
                <li onClick={()=>dispatch(push('/tradelaw'))}>特定商取引法に基づく表記</li>
            </Menu>
            <div className='spacer-50'></div>
            <div style={{fontSize: '.7rem'}}>
                <p>&copy; To The Top</p>
            </div>
            <div className='spacer-100'></div>
        </Wrapper>
    )
}

export default Footer

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    background-color: #000;
    color: #FDFDEB;
`
const Menu = styled.ul`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: 0.8rem;
    max-width: 640px;
    li {
        display: inline-block;
        cursor: pointer;
        text-align: center;
    }
    @media screen and (max-width:768px){
        flex-wrap: wrap;
        li {
            width: 100%;
            margin-bottom: 20px;
        }
    }
`
// const Icons = styled.ul`
//     display: flex;
//     flex-direction: row;
//     justify-content: space-between;
//     align-items: center;
//     width: 100%;
//     max-width: 320px;
//     li {
//         display: inline-block;
//         cursor: pointer;
//         text-align: center;
//     }
// `